import axios from 'axios';

const updateLotMeasurementUnits = function () {
  axios
    .get('/product_measurement_units', {
      params: { product_id: $('#product_lot_product_id').val() },
    })
    .then(response => {
      const unitSelect = $('#product_lot_measurement_unit_id');
      unitSelect.empty();
      $.each(response.data, function (_, unit) {
        unitSelect.append(
          $('<option>', {
            text: unit.name_and_description,
            value: unit.id,
          })
        );
      });
      unitSelect.trigger('change');
    })
    .catch(error => {
      console.log(error.response.data);
    });
};

const updateAreas = function () {
  axios
    .get('/areas_by_warehouse', {
      params: { warehouse_id: $('.warehouse_select').val() },
    })
    .then(response => {
      const areaSelect = $('.area_select');
      $('.area_select option:not(:first)').remove();
      $.each(response.data, function (_, area) {
        areaSelect.append(
          $('<option>', {
            text: area.code_and_description,
            value: area.id,
          })
        );
      });
      areaSelect.trigger('change');
    })
    .catch(error => {
      console.log(error.response.data);
    });
};

const toggleEnabledForProductionSwitch = function () {
  if (
    $('.product_lots_form .product_select').length &&
    $('.product_lots_form .product_select').val() !== ''
  ) {
    axios
      .get('/product_for_production.json', {
        params: { product_id: $('.product_lots_form .product_select').val() },
      })
      .then(response => {
        const enabled = response.data;
        const enabledForProductionSwitch = $('.enabled_for_production');
        enabledForProductionSwitch
          .parent()
          .parent()
          .toggleClass('d-none', !enabled);

        if (document.querySelector('.new_product_lot .product_lots_form')) {
          enabledForProductionSwitch.prop('checked', enabled);
        }

        if (enabled === false) {
          $('.lot_plant_select option:selected').removeAttr('selected');
          $('.lot_plant_select').trigger('change');
        }
        $('.lot_plant_select_div').toggleClass('d-none', !enabled);
      })
      .catch(error => {
        console.log(error.response.data);
      });
  }
};

// Prevents the user from saving a product lot without at least one location
// Deletes the remove button when there's only one nested field.
const deleteLocationRemoveButton = function (useVisibleLocationsOnly) {
  let locations;
  if (useVisibleLocationsOnly === true) {
    locations = $('.product_lot_locations .nested-fields:visible');
  } else {
    locations = $('.product_lot_locations .nested-fields');
  }
  if (locations.length === 1) {
    locations.find('.remove_fields').remove();
  }
};

// Allow to search for warehouses showing their children
const applyLocationSelect2 = () => {
  $('.location_select').select2({
    placeholder: 'Buscar por almacén, área o ubicación...',
    minimumInputLength: 2,
    width: '100%',
    matcher(params, data) {
      const originalMatcher = $.fn.select2.defaults.defaults.matcher;
      const result = originalMatcher(params, data);
      if (
        result &&
        data.children &&
        result.children &&
        data.children.length !== result.children.length &&
        data.text.toLowerCase().includes(params.term)
      ) {
        result.children = data.children;
      }
      return result;
    },
  });
};

document.addEventListener('turbolinks:load', function () {
  $('.product_select').select2({
    placeholder: 'Buscar un producto (código o nombre)',
    minimumInputLength: 3,
    width: '100%',
  });
  $('.product_lot_select').select2({
    placeholder: 'Buscar un lote (código o producto)',
    minimumInputLength: 3,
    width: '100%',
  });
  $('.lot_plant_select').select2({
    placeholder: 'Seleccione una o varias plantas',
    width: '100%',
  });
  $('.lot_unit_select').select2({
    placeholder: 'Seleccione una unidad de medida',
  });
  $('.warehouse_select').on('change', updateAreas);

  toggleEnabledForProductionSwitch();

  if (
    $('.product_lots_form #product_lot_product_id').val() &&
    !$('.product_lots_form #product_lot_measurement_unit_id').val()
  ) {
    updateLotMeasurementUnits();
  }

  $('.product_lots_form .product_select').on('change', function () {
    toggleEnabledForProductionSwitch();
    updateLotMeasurementUnits();
  });

  if (document.querySelector('.product_lot_locations')) {
    deleteLocationRemoveButton(false);
  }

  applyLocationSelect2();
  $('.product_lot_locations').on('cocoon:after-insert', function () {
    applyLocationSelect2();
    deleteLocationRemoveButton(true);
    $('[data-toggle="tooltip"]').tooltip();
  });

  $('.product_lot_locations').on('cocoon:after-remove', function () {
    deleteLocationRemoveButton(true);
  });
});
